/**
 * Changelog entries — append new releases at the TOP.
 * Each entry: { date: 'YYYY-MM-DD', items: [{ id, kind, title, body }] }
 *   kind: 'feat' | 'fix' | 'ui' | 'perf' | 'backend' | 'test'
 *   id:   stable string unique within the entry (used as React key)
 */
const ENTRIES = [
  {
    date: "2026-09-30",
    items: [
      {
        id: "20260930-security-hardening",
        kind: "fix",
        title: "Sicurezza: dati protetti da login e schermatura anti-XSS",
        body:
          "A seguito di un audit di sicurezza completo, sono state applicate " +
          "due protezioni fondamentali. 1) L'endpoint di sincronizzazione " +
          "dati ora richiede una sessione valida: senza login non è più " +
          "possibile né leggere né scrivere i dati aziendali (prima era " +
          "accessibile pubblicamente). 2) Oltre 100 punti dell'interfaccia " +
          "che mostrano testi inseriti dagli utenti (negozi, operatori, " +
          "note, email, descrizioni di fatture e spese...) ora neutralizzano " +
          "automaticamente qualsiasi codice malevolo incorporato nei dati " +
          "(protezione XSS). Verificato dal team di test: 52/52 test backend " +
          "superati, iniezioni di codice neutralizzate, tutti i flussi " +
          "(inserimento, modifica, buste, accesso negozio a 2 livelli) " +
          "funzionano invariati.",
      },
    ],
  },
  {
    date: "2026-07-14",
    items: [
      {
        id: "20260714-code-review",
        kind: "backend",
        title: "Qualità del codice: review applicata e test riparati",
        body:
          "Applicati i fix della code review: eliminata la dipendenza " +
          "circolare tra i moduli del backend (ora il flusso è a senso " +
          "unico, più stabile agli avvii) e semplificata la funzione dello " +
          "storico accessi admin, scomposta in helper più piccoli e " +
          "testabili — comportamento invariato, verificato end-to-end. " +
          "Riparati inoltre 5 test automatici che erano rimasti indietro " +
          "rispetto alle evoluzioni recenti (chiave di idempotenza email e " +
          "semantica di merge del backup cloud). Suite completa: 58 test " +
          "superati, 0 falliti.",
      },
      {
        id: "20260714-stop-email-2300",
        kind: "fix",
        title: "Stop definitivo alle email duplicate delle 23:00",
        body:
          "Individuata la causa delle email duplicate serali: processi con " +
          "una vecchia versione del sistema (orario 23:00, senza protezione " +
          "anti-duplicati) ancora attivi sull'infrastruttura. La chiave di " +
          "invio email è stata rigenerata e quella vecchia revocata: i " +
          "processi fantasma non possono più inviare nulla. Resta attivo " +
          "solo l'invio ufficiale delle 21:35 con lucchetto anti-duplicati.",
      },
      {
        id: "20260714-negozi-senza-chiusura",
        kind: "feat",
        title: "Email di riepilogo: elenco dei negozi senza chiusura",
        body:
          "Le email di riepilogo giornaliero (e il PDF allegato) ora includono " +
          "la sezione \"Negozi senza chiusura\": l'elenco esplicito dei negozi " +
          "che non hanno inserito la giornata. Prima, se un negozio non " +
          "caricava la chiusura, il riepilogo mostrava semplicemente totali a " +
          "zero senza dire quali punti vendita mancassero. Ogni destinatario " +
          "vede solo i negozi del proprio perimetro (l'Area Manager vede le " +
          "sue aree, l'amministrazione tutti). La sezione compare solo se " +
          "manca almeno una chiusura.",
      },
      {
        id: "20260714-filtro-da-rivedere",
        kind: "feat",
        title: "Tab Buste: clic su \"da rivedere\" per filtrare la tabella",
        body:
          "Nell'header della tabella \"Giornate disponibili\", la label rossa " +
          "\"N da rivedere\" ora è cliccabile: un clic mostra solo le giornate " +
          "fuori quadratura, un secondo clic (o la ✕) torna alla vista " +
          "completa. Quando il filtro è attivo la label si evidenzia con un " +
          "bordo rosso. Il filtro è alternativo a \"Solo quadrate\": " +
          "attivandone uno, l'altro si disattiva da solo.",
      },
      {
        id: "20260714-fix-modifica-centesimo",
        kind: "fix",
        title: "Le modifiche da 1 centesimo ora vengono salvate",
        body:
          "Corretto un bug per cui modificando un importo di un solo " +
          "centesimo (es. POS fisico da €474,99 a €475,00) il salvataggio " +
          "veniva silenziosamente ignorato: il sistema considerava i due " +
          "valori \"uguali\" per via di una tolleranza troppo larga nel " +
          "confronto, mentre il controllo di quadratura (più severo) " +
          "continuava a segnalare la giornata come da rivedere. Ora il " +
          "rilevamento delle modifiche confronta i centesimi esatti e la " +
          "tolleranza di quadratura è unificata ovunque a mezzo centesimo: " +
          "quello che correggi viene salvato e la label di attenzione " +
          "sparisce.",
      },
      {
        id: "20260714-dettaglio-giornata-buste",
        kind: "feat",
        title: "Tab Buste: clic sulla data per vedere il dettaglio giornata",
        body:
          "Nella tabella \"Giornate disponibili\" del tab Buste, cliccando " +
          "sulla data si apre ora il dettaglio completo della giornata: " +
          "totale, riquadri Cassa e POS con il delta di quadratura " +
          "evidenziato (utilissimo per capire al volo perché una giornata è " +
          "\"da rivedere\"), fatture, spese, scontrini, note, suggerimenti e " +
          "storia modifiche. Dal dettaglio si può agire direttamente — " +
          "Modifica, Chiudi, Risolvi quadratura — con le stesse azioni e gli " +
          "stessi permessi delle card dei Corrispettivi.",
      },
    ],
  },
  {
    date: "2026-07-13",
    items: [
      {
        id: "20260713-orario-2135",
        kind: "feat",
        title: "Riepilogo serale alle 21:35 + orario con i minuti",
        body:
          "Su richiesta, l'email di riepilogo giornaliero ora parte alle " +
          "21:35 invece che alle 23:00 (il cambio avviene automaticamente al " +
          "primo avvio dopo l'aggiornamento). Il pannello Impostazioni → " +
          "Riepiloghi email ora permette di scegliere anche i MINUTI (a passi " +
          "di 5) per gli invii giornalieri, settimanali e mensili. Verificato " +
          "dal team di test: migrazione automatica, salvataggio e persistenza " +
          "degli orari personalizzati, e conferma finale del fix anti-" +
          "duplicati (5 processi concorrenti → 1 solo invio; doppio invio " +
          "con stessa chiave → una sola email consegnata). In più: se " +
          "l'invio serale fallisce, il sistema può ora ritentare senza " +
          "attendere il giorno dopo.",
      },
    ],
  },
  {
    date: "2026-07-10",
    items: [
      {
        id: "20260710-test-email-reali",
        kind: "fix",
        title: "Trovata l'ultima fonte di email duplicate: i test automatici",
        body:
          "Individuata la fonte principale delle email di riepilogo ripetute: " +
          "due test automatici dell'ambiente di sviluppo inviavano email VERE " +
          "all'amministrazione a ogni esecuzione della suite di verifica (un " +
          "\"Riepilogo Incassi 22/05/2026\" e una email di test). Le date " +
          "degli invii registrati combaciano esattamente con i duplicati " +
          "segnalati. I test ora usano la sandbox ufficiale di Resend " +
          "(delivered@resend.dev) o tenant fittizi senza destinatari: " +
          "verificato che un'esecuzione completa della suite non genera più " +
          "alcun invio reale. Insieme al lock anti-repliche e " +
          "all'idempotenza già attivi, da stasera deve arrivare una sola " +
          "email di riepilogo al giorno.",
      },
    ],
  },
  {
    date: "2026-07-09",
    items: [
      {
        id: "20260709-fix-email-duplicate",
        kind: "fix",
        title: "Stop alle email di riepilogo duplicate",
        body:
          "Segnalate 4-5 email di riepilogo giornaliero arrivate insieme. " +
          "Cause individuate e risolte con una tripla protezione: (1) un " +
          "LOCK condiviso sul database garantisce che, anche se in produzione " +
          "girano più processi in parallelo (ognuno col proprio scheduler " +
          "delle 23:00), solo UNO invii il riepilogo del giorno; (2) ogni " +
          "invio ora passa a Resend una chiave di idempotenza: se un " +
          "tentativo va in timeout e viene ritentato, il server della posta " +
          "riconosce il duplicato e non lo re-invia (verificato: stesso ID, " +
          "una sola consegna); (3) l'ambiente di sviluppo non invia più " +
          "riepiloghi automatici serali (restano disponibili i test manuali " +
          "dal pannello). Il re-invio manuale volontario dal pannello " +
          "continua a funzionare normalmente.",
      },
      {
        id: "20260709-pdf-riepiloghi",
        kind: "feat",
        title: "PDF allegato ai riepiloghi email",
        body:
          "Le email automatiche (giornaliere, settimanali e mensili) ora " +
          "possono includere un PDF professionale del riepilogo, pronto da " +
          "stampare o archiviare: totali, dettaglio per negozio e per " +
          "operatore, anomalie, giornate fuori quadratura e modifiche " +
          "manuali. Si attiva da Impostazioni → Riepiloghi email → \"Allega " +
          "PDF del riepilogo\" (per le nuove installazioni è attivo di " +
          "default). Il nome file include tipo, data e ambito del " +
          "destinatario. Se la generazione del PDF dovesse fallire, l'email " +
          "parte comunque senza allegato.",
      },
      {
        id: "20260709-diff-email",
        kind: "feat",
        title: "Email serali: sezione \"Modifiche manuali\" (chi ha cambiato cosa)",
        body:
          "I riepiloghi email ora includono una sezione dedicata alle " +
          "modifiche manuali effettuate nel periodo: per ogni correzione si " +
          "vede la giornata interessata, chi l'ha modificata, quando, e il " +
          "dettaglio campo per campo (valore prima → valore dopo, incluse " +
          "data e negozio ora modificabili dagli AM). Il filtro è sulla data " +
          "della MODIFICA: una giornata di ieri corretta oggi compare nel " +
          "riepilogo di oggi. Ogni Area Manager vede solo le modifiche dei " +
          "propri negozi. Nella stessa release: la sezione \"giornate fuori " +
          "quadratura\" (già calcolata) ora viene mostrata anche nel corpo " +
          "dell'email, e ogni modifica registra un timestamp preciso con " +
          "fuso orario per un filtro affidabile.",
      },
    ],
  },
  {
    date: "2026-07-08",
    items: [
      {
        id: "20260708-am-edit-negozio",
        kind: "feat",
        title: "Modifica giornata: si può cambiare anche il negozio/sede",
        body:
          "Nel form di modifica, accanto alla data, ora si può correggere " +
          "anche il negozio della giornata: utile quando una chiusura viene " +
          "inserita sulla sede sbagliata. Gli Area Manager vedono solo i " +
          "negozi del proprio ambito (negozi assegnati o area gestita), il " +
          "Super Admin tutti. Cambiando negozio l'area della giornata si " +
          "aggiorna automaticamente, il sistema impedisce di creare doppioni " +
          "(stessa data + stesso negozio) e ogni cambio — negozio, area e " +
          "data — viene registrato nella storia modifiche della giornata.",
      },
      {
        id: "20260708-am-edit-data",
        kind: "feat",
        title: "Gli Area Manager possono modificare la data delle giornate",
        body:
          "Il campo \"Data giornata\" nel form di modifica, prima riservato ad " +
          "Amministrazione e Super Admin, è ora disponibile anche agli Area " +
          "Manager: utile quando un negozio inserisce una chiusura con la data " +
          "sbagliata. Restano attive tutte le protezioni esistenti: non si può " +
          "spostare una giornata su una data già occupata dallo stesso negozio, " +
          "il valore originale resta visibile accanto al campo e ogni cambio di " +
          "data viene registrato nella storia modifiche della giornata (audit " +
          "trail). Le giornate già imbustate, checkate o chiuse dal SA restano " +
          "bloccate come prima.",
      },
    ],
  },
  {
    date: "2026-07-07",
    items: [
      {
        id: "20260707-cestino-giornate",
        kind: "feat",
        title: "Cestino giornate: ripristino con un clic entro 90 giorni",
        body:
          "Nuova rete di sicurezza per il Super Admin: le giornate eliminate " +
          "non spariscono più per sempre, ma finiscono in un Cestino " +
          "(Impostazioni → Cestino giornate) dove restano recuperabili per 90 " +
          "giorni. Per ogni giornata eliminata si vede data, negozio, " +
          "operatore, totale RT, quando è stata eliminata e da chi. Con " +
          "\"Ripristina\" la giornata torna nell'archivio e si propaga a " +
          "tutti i dispositivi alla sincronizzazione successiva — anche i " +
          "dispositivi rimasti indietro non possono più ri-cancellarla per " +
          "sbaglio. Ogni ripristino è tracciato nello Storico accessi " +
          "(evento \"Giornata ripristinata\"). Coperto da test automatici " +
          "dedicati (archiviazione, ripristino, no-risurrezione, permessi).",
      },
      {
        id: "20260707-ip-reale-bruteforce",
        kind: "fix",
        title: "Protezione brute-force: ora usa l'IP reale del cliente",
        body:
          "Verifica completa di stabilità dell'app (55 test automatici, tutti " +
          "verdi). Durante i controlli è emerso che, dietro il proxy " +
          "dell'infrastruttura, il server registrava l'IP interno del cluster " +
          "(variabile tra le richieste) invece dell'IP reale del cliente: la " +
          "protezione anti brute-force sul login si frammentava su più " +
          "contatori e i log di audit contenevano IP non significativi. Ora " +
          "l'IP viene letto correttamente dall'header X-Forwarded-For " +
          "impostato dal proxy fidato (con fallback a X-Real-IP): lockout " +
          "progressivo (3s → 9s → 27s…) e blocco 15 minuti dopo 5 tentativi " +
          "tornano pienamente efficaci, e l'audit registra l'indirizzo vero.",
      },
    ],
  },
  {
    date: "2026-07-06",
    items: [
      {
        id: "20260706-creazione-utenti-veloce",
        kind: "perf",
        title: "Creazione utenti 18× più veloce",
        body:
          "La creazione di un utente impiegava 4-10 secondi: per verificare " +
          "l'unicità del codice di accesso, il server confrontava il codice con " +
          "l'hash bcrypt di OGNI utente attivo (~250ms l'uno, sempre peggio al " +
          "crescere degli utenti). Ora l'unicità è verificata con una singola " +
          "query indicizzata istantanea; il costoso confronto bcrypt resta solo " +
          "per eventuali utenti legacy senza codice in chiaro, ed è eseguito " +
          "fuori dal loop principale del server (non blocca più le altre " +
          "richieste). Stessa ottimizzazione applicata a \"Imposta codice " +
          "manualmente\". Tempo misurato: da 4,5s a 0,25s senza email; con " +
          "invio email resta solo il tempo di consegna (~1s).",
      },
    ],
  },
  {
    date: "2026-07-04",
    items: [
      {
        id: "20260704-merge-anti-perdita",
        kind: "fix",
        title: "Sincronizzazione multi-dispositivo: mai più giornate perse",
        body:
          "Risolto il bug per cui una giornata salvata da un negozio poteva " +
          "sparire (caso Udine): il salvataggio cloud sovrascriveva l'intero " +
          "archivio, quindi un dispositivo rimasto aperto con dati non aggiornati " +
          "poteva cancellare le giornate salvate nel frattempo da altri. Ora il " +
          "server esegue un MERGE record-per-record: ogni giornata/busta/" +
          "versamento ha un timestamp di modifica (vince la versione più " +
          "recente) e i record assenti nel salvataggio di un dispositivo NON " +
          "vengono più cancellati. Le eliminazioni esplicite viaggiano come " +
          "\"tombstone\" dedicate, così un dispositivo non aggiornato non può " +
          "far risorgere una giornata eliminata. In più: ogni dispositivo " +
          "aperto si riallinea automaticamente al cloud ogni 60 secondi, senza " +
          "bisogno di ricaricare la pagina. Copertura test: 5 casi pytest " +
          "dedicati (merge multi-device, conflitti, tombstone, contatori).",
      },
      {
        id: "20260704-logout-chiusura-browser",
        kind: "fix",
        title: "Chiusura browser = logout completo",
        body:
          "Dopo la rimozione del timeout di sessione, chiudendo e riaprendo il " +
          "browser l'app si riapriva con l'ultimo utente collegato. Ora un " +
          "heartbeat locale rileva la vera riapertura del browser (anche quando " +
          "il browser \"ripristina le schede precedenti\"): se l'app viene " +
          "riaperta dopo più di 90 secondi dall'ultima attività, la sessione " +
          "viene invalidata e si torna alla schermata di accesso. Finché il " +
          "browser resta aperto, nessun timeout: si continua a lavorare senza " +
          "interruzioni.",
      },
      {
        id: "20260704-scoping-nomi-negozio",
        kind: "fix",
        title: "Negozi assegnati: confronto nomi robusto (caso Nancy/Udine)",
        body:
          "Un'Area Manager con il negozio \"Udine\" assegnato non vedeva i dati " +
          "del negozio \"LIB Udine\": il confronto dei nomi era esatto e " +
          "case-sensitive. Ora ovunque (Corrispettivi, Nuova giornata, Buste, " +
          "Versamenti, login operatore e profili al gate) il confronto è " +
          "case-insensitive, ignora spazi doppi e il prefisso \"LIB\" è " +
          "opzionale: \"Udine\", \"lib udine\" e \"LIB Udine\" ora coincidono. " +
          "In più i permessi del profilo (negozi/aree assegnati) si aggiornano " +
          "automaticamente ogni minuto senza dover rifare il login: se il Super " +
          "Admin assegna un nuovo negozio, l'utente lo vede comparire da solo.",
      },
    ],
  },
  {
    date: "2026-07-02",
    items: [
      {
        id: "20260702-refactor-quality",
        kind: "chore",
        title: "Refactor di qualità: import utenti, template XLSX, login, create/update user",
        body:
          "Applicate le raccomandazioni della revisione di code quality: le funzioni " +
          "più complesse di auth_routes.py sono state suddivise in helper puri e " +
          "testabili, riducendo drasticamente la complessità ciclomatica senza " +
          "cambiare il comportamento esterno. In dettaglio: " +
          "• import_users (era complexity 62 su 180 righe): estratti " +
          "_load_existing_shops, _import_row_normalize, _import_row_validate, " +
          "_import_row_upsert e _import_result_error — la funzione principale ora è " +
          "un orchestratore da ~80 righe. " +
          "• _build_import_template_xlsx (era complexity 12): estratti " +
          "_template_header_styles, _add_utenti_sheet, _add_negozi_sheet, " +
          "_add_istruzioni_sheet, più costanti a livello di modulo. " +
          "• _parse_import_rows (era complexity 16): estratti _read_raw_rows e " +
          "_build_col_index. " +
          "• create_user (era complexity 29): estratti _resolve_unique_code e " +
          "_split_areas. Corretto anche un piccolo bug: se un lv0 senza email veniva " +
          "creato, il log audit tentava di leggere user_doc['email'] causando " +
          "KeyError (ora usa .get). " +
          "• update_user (era complexity 28): estratti _resolve_email_update, " +
          "_apply_areas_update e _build_user_update. " +
          "• login (era complexity 12): estratto _audit_event che elimina 30+ righe " +
          "di boilerplate audit. " +
          "Sul frontend: rimossi ENTRIES dalle deps dei useMemo in Changelog.jsx " +
          "(ENTRIES è import module-scoped e non cambia mai). Aggiunto commento " +
          "esplicativo sul disable-eslint di use-toast.js.",
      },
    ],
  },
  {
    date: "2026-06-26",
    items: [
      {
        id: "20260626-scope-utente-globale",
        kind: "feat",
        title: "Corrispettivi/Buste/Versamenti: rispettano tutti i negozi assegnati al profilo",
        body:
          "Applicato in modo consistente in tutta l'app il principio \"negozi " +
          "assegnati batte area\": se un utente ha uno o più negozi assegnati " +
          "esplicitamente sul suo profilo, vede SOLO i dati di quei negozi in " +
          "tutti i tab principali — Corrispettivi (lista + filtro Negozio), " +
          "Buste (lista + selettore giornate da imbustare + filtro), Versamenti " +
          "(buste disponibili per creare un versamento + filtro giorni). Se non " +
          "ha negozi assegnati, si torna al comportamento precedente: Area " +
          "Manager filtra per aree gestite (multi o singola), Amministrazione " +
          "e Super Admin vedono tutto. Introdotto anche il supporto nativo alla " +
          "multi-area (u.areas) per gli AM che gestiscono più zone " +
          "contemporaneamente. Nuovo helper interno _scopeForUser() centralizza " +
          "la logica ed evita divergenze future.",
      },
      {
        id: "20260626-nuova-giornata-negozi-utente",
        kind: "fix",
        title: "Nuova giornata: selettore negozi rispetta l'assegnazione esplicita al profilo",
        body:
          "Corretto un comportamento controintuitivo: quando un utente (di qualsiasi ruolo) " +
          "creava una nuova giornata, il selettore \"Negozio\" mostrava i negozi in base " +
          "all'AREA di appartenenza dell'utente e non ai negozi effettivamente assegnati " +
          "al suo profilo. Ora la priorità è invertita: se l'utente ha uno o più negozi " +
          "assegnati esplicitamente (colonna \"Negozi assegnati\" nel modale Modifica utente), " +
          "il selettore mostra SOLO quelli, indipendentemente dall'area di riferimento. " +
          "Fallback per retro-compatibilità (solo se il profilo non ha negozi espliciti): " +
          "• Area Manager (lv3) → filtra per aree gestite (u.areas o u.area). " +
          "• Amministrazione (lv4) e Super Admin (lv5) → tutti i negozi. " +
          "Sistemata anche l'inizializzazione di S.cu che ora popola sempre correttamente " +
          "i campi u.negozi e u.areas in TUTTI i flussi di login (doLogin, doOperatorLogin, " +
          "doOperatorAuthFromModal, bootstrapSession).",
      },
      {
        id: "20260626-negozi-assegnati-piena-opacita",
        kind: "fix",
        title: "Modale utente: campo \"Negozi assegnati\" sempre a piena opacità con hint contestuale",
        body:
          "Il campo \"Negozi assegnati\" nel modale Modifica/Nuovo utente veniva " +
          "reso al 45% di opacità (grigio spento) per qualsiasi ruolo diverso da " +
          "Operatore o Shop Manager — un residuo del vecchio comportamento che " +
          "assumeva che solo lv1/lv2 potessero avere negozi. Ora la sezione è " +
          "sempre a piena opacità (colore pieno, leggibile) e mostra un hint " +
          "contestuale coerente col ruolo selezionato: " +
          "• Operatore/Shop Manager → \"(per Operatori e Shop Manager)\" + testo su parcheggio account; " +
          "• Area Manager → \"(facoltativo — filtra la visibilità)\" + testo che ricorda che gli AM gestiscono per zona; " +
          "• Amministrazione / Super Admin → \"(facoltativo — filtra la visibilità)\" + testo generico; " +
          "• Negozio (lv0) → \"(il negozio stesso)\".",
      },
      {
        id: "20260626-user-search-fulltext",
        kind: "feat",
        title: "Ricerca full-text nella tabella Utenti",
        body:
          "Aggiunta una barra di ricerca in cima alla tabella Utenti " +
          "(Impostazioni → Utenti). Cerca istantaneamente per: nome, email, " +
          "ruolo (in italiano — es. \"amministrazione\", \"shop manager\"), area " +
          "(es. \"nord ovest\", \"centro\"), negozi assegnati e codice di accesso. " +
          "Il conteggio in alto a destra si aggiorna in tempo reale (es. \"3/17 utenti\"). " +
          "Combinabile con i filtri esistenti (ruolo/area/stato). Il pulsante X " +
          "dentro l'input pulisce solo la ricerca; \"Reset\" pulisce tutto insieme.",
      },
      {
        id: "20260626-modale-utente-fix",
        kind: "fix",
        title: "Modale gestione utente: dropdown negozi/aree fissata + tabella profili mostra i negozi anche per lv3/lv4/lv5",
        body:
          "Due problemi risolti nella schermata Impostazioni → Utenti: " +
          "(1) UI: quando si apriva la dropdown \"Negozi assegnati\" (o \"Aree gestite\") " +
          "nel modale Modifica utente, la lista si sovrapponeva visivamente al campo " +
          "\"Codice di accesso\" e ai bottoni \"Annulla / Salva modifiche\" a causa di un " +
          "conflitto tra position:absolute della dropdown e l'overflow:auto del modale. " +
          "Ora la dropdown è in-flow (inline): quando aperta spinge giù il resto del " +
          "modale che scrolla naturalmente, mantenendo tutti gli elementi ben separati " +
          "e leggibili. " +
          "(2) Dato: nella tabella \"Utenti · Accesso al sistema\" la colonna \"Negozi " +
          "assegnati\" mostrava sempre un trattino (—) per Area Manager, Amministrazione " +
          "e Super Admin, anche quando avevi effettivamente assegnato negozi specifici " +
          "a questi profili. Ora i negozi assegnati appaiono correttamente per TUTTI i " +
          "ruoli, con badge grigio-chiaro accanto al nome dell'utente. Per lv1/lv2 " +
          "senza negozi assegnati resta il warning rosso \"nessuno\"; per gli altri ruoli " +
          "senza negozi resta il trattino \"—\" (comportamento invariato).",
      },
      {
        id: "20260626-card-border-dinamico",
        kind: "fix",
        title: "Bordo card giornata: ora ricalcolato dai dati attuali",
        body:
          "Risolto: una giornata che era stata salvata come \"anomalia\" (es. " +
          "perché POS Fresha ≠ POS Fisico al momento del primo save) e che " +
          "successivamente veniva bilanciata aggiungendo una fattura POS, " +
          "continuava a mostrare il bordo rosso ai lati della card anche " +
          "se la pill in alto era diventata \"Quadr.\". Ora il colore del " +
          "bordo (verde/arancione/rosso) viene SEMPRE ricalcolato dai dati " +
          "attuali della giornata tramite isQuadrataGiornata() — non si " +
          "fida più dello status salvato originariamente. Stesso fix " +
          "applicato anche alla card della vista \"Riepilogo mensile\" (la " +
          "pill ora dice \"Quadr.\" o \"Da rivedere\" coerentemente al bordo).",
      },
      {
        id: "20260626-sessione-persistente",
        kind: "feat",
        title: "Sessione persistente — niente più scadenza durante l'inserimento",
        body:
          "Rimossi tutti i timeout automatici di sessione. Una volta effettuato il login " +
          "(sia direttamente come Super Admin/Area Manager/Amministrazione/Shop Manager, " +
          "sia come operatore dentro un negozio kiosk), l'utente resta dentro " +
          "fino al logout esplicito (pulsante \"Esci\" / \"Cambia utente\") o " +
          "alla chiusura del browser. " +
          "PRIMA: la sessione operatore scadeva dopo 15 minuti tornando in " +
          "modalità sola lettura — questo poteva fa perdere il salvataggio " +
          "se l'utente stava ancora compilando una giornata. Inoltre il JWT " +
          "backend scadeva dopo 8 ore. " +
          "ORA: il chip countdown \"15:00\" in alto è stato rimosso, il timer " +
          "JS che faceva switchUser automatico è disattivato, e il JWT del " +
          "cookie dura 365 giorni (di fatto: tutta la sessione del browser). " +
          "Il cookie resta comunque session-cookie: alla chiusura del browser " +
          "viene cancellato e al prossimo avvio si chiede di nuovo il login. " +
          "Il pulsante \"Cambia utente\" resta disponibile per chiudere " +
          "volontariamente la sessione operatore.",
      },
      {
        id: "20260626-chip-tempo-relativo",
        kind: "ui",
        title: "Chip cloud: ora mostra anche \"adesso · 2 min fa · 1 ora fa\"",
        body:
          "L'indicatore di sincronizzazione in alto a destra ora include in modo " +
          "ben visibile il tempo trascorso dall'ultimo backup cloud andato a buon " +
          "fine: \"Sincronizzato · adesso\", \"Sincronizzato · 30 sec fa\", " +
          "\"Sincronizzato · 5 min fa\", \"Sincronizzato · 2 ore fa\", \"Sincronizzato · " +
          "3 giorni fa\". Il testo si aggiorna automaticamente ogni 20 secondi senza " +
          "bisogno di refresh. Tooltip esteso al passaggio del mouse mostra " +
          "data e ora esatta dell'ultimo sync. Click sul chip → forza un nuovo " +
          "push immediato al cloud. Rassicurazione visiva totale per gli utenti " +
          "nei negozi.",
      },
      {
        id: "20260626-cloud-sync-robusto",
        kind: "fix",
        title: "Sincronizzazione cloud robusta — niente più giornate perse",
        body:
          "Risolto un problema critico per cui i corrispettivi giornalieri salvati " +
          "potevano sparire al refresh o al cambio device. Cinque modifiche: " +
          "(1) flush automatico all'uscita: chiudendo il tab/scheda, eventuali " +
          "modifiche non ancora sincronizzate vengono spedite al server via " +
          "navigator.sendBeacon (resiste anche allo unload del browser). " +
          "(2) compare-and-merge all'avvio: se il browser ha modifiche locali più " +
          "recenti del cloud, ora vengono PUSH al cloud invece di essere " +
          "sovrascritte dalla versione cloud più vecchia. " +
          "(3) debounce di sincronizzazione ridotto da 1500ms a 400ms — " +
          "meno finestra di rischio se l'utente chiude la pagina subito dopo. " +
          "(4) nuovo stato della chip in header: \"Da sincronizzare\" (arancione) " +
          "appare se ci sono modifiche locali non ancora salvate sul cloud; clic " +
          "per forzare il push immediato. \"Sincronizzato\" (verde) conferma " +
          "che tutti i dati sono al sicuro. " +
          "(5) backup immediato (no debounce) dopo i salvataggi critici — nuova " +
          "giornata, modifica giornata, creazione/eliminazione busta, eliminazione " +
          "giornata: il server riceve subito i dati prima che il form si chiuda.",
      },
    ],
  },
  {
    date: "2026-06-25",
    items: [
      {
        id: "20260625-fatture-quadratura",
        kind: "fix",
        title: "Card giornata: fatture visibili + Δ Quadratura POS finalmente corretto",
        body:
          "Sulla card di dettaglio della giornata (tab Corrispettivi) ora è presente " +
          "una nuova mini-card \"Fatture\" che elenca le fatture inserite con icona " +
          "POS sui pagamenti elettronici e il totale. La Δ Quadratura POS ora " +
          "include correttamente le fatture flaggate POS (formula: Fisico = RT + " +
          "Fatture POS), e la Δ Quadratura Cassa include le fatture in contanti e le " +
          "spese. Le righe \"+ Ft. POS\" e \"+ Ft. cont.\" / \"+ Spese\" compaiono " +
          "nelle card Cassa e POS quando ci sono valori, mostrando dove va ciascuna " +
          "voce nel calcolo. Allineata anche la funzione globale " +
          "isQuadrataGiornata() che ora separa correttamente fatture cassa e POS, " +
          "eliminando il falso \"Da rivedere\" su giornate effettivamente quadrate.",
      },
      {
        id: "20260625-rate-limit-progressivo",
        kind: "feat",
        title: "Login: attesa progressiva crescente dopo tentativi falliti",
        body:
          "Per scoraggiare attacchi brute force, dopo ogni tentativo di login fallito " +
          "il prossimo tentativo è bloccato per un tempo che cresce esponenzialmente: " +
          "3 secondi al primo fallimento, poi 9, 27, 81, 243 secondi (×3 ogni volta) " +
          "fino a un massimo di 30 minuti. Il contatore si resetta dopo un'ora di " +
          "inattività o dopo un login riuscito. Si applica sia all'accesso principale " +
          "sia al codice operatore dentro il Modal Kiosk. Sul pulsante \"Accedi\" " +
          "compare un countdown live (\"Attendi 9s\"); l'input viene disabilitato " +
          "finché il timer non scade. Il limite \"hard\" di 5 fallimenti in 15 min con " +
          "lockout di 15 min resta attivo come protezione finale.",
      },
      {
        id: "20260625-pos-quadratura-verde",
        kind: "feat",
        title: "Form Nuova giornata: colonna POS in verde quando la quadratura è perfetta",
        body:
          "Nella form di inserimento giornata, quando POS Fresha = POS Fisico = " +
          "(POS RT + somma fatture flaggate POS), tutta la colonna POS diventa " +
          "verde — non solo i 3 input principali (Fresha/RT/Busta) come prima, " +
          "ma anche i pulsanti POS attivati sulle singole righe fattura. Conferma " +
          "visiva immediata della quadratura.",
      },
      {
        id: "20260625-cestino-giornate-legacy",
        kind: "fix",
        title: "Cestino giornate: corretto errore \"Giornata non trovata\"",
        body:
          "Alcune giornate seed/legacy presenti nel cloud erano prive del campo " +
          "id, quindi premere il cestino restituiva un errore. Ora al caricamento " +
          "dei dati dal cloud, eventuali record senza id vengono automaticamente " +
          "riparati (id univoco assegnato e push silenzioso sul cloud) e cancellabili " +
          "normalmente. Aggiunto safety-net: se un id arriva come stringa " +
          "\"undefined\" o vuota, l'app propone l'eliminazione bulk delle giornate " +
          "orfane (con conferma utente).",
      },
      {
        id: "20260625-sync-indicator",
        kind: "feat",
        title: "Indicatore di sincronizzazione cloud nell'header",
        body:
          "Accanto al pulsante Esci compare ora un piccolo chip che mostra in tempo " +
          "reale lo stato della sincronizzazione cloud: \"Sincronizzato\" (verde) " +
          "quando i dati sono al sicuro sul server, \"Sincronizzo…\" (arancione con " +
          "icona animata) durante un upload, \"Errore sync\" (rosso) in caso di " +
          "fallimento, \"Offline\" (grigio) se la connessione è caduta. Click sul chip " +
          "forza una sincronizzazione immediata. Tooltip mostra l'orario dell'ultimo " +
          "sync riuscito o il messaggio di errore. Su mobile il testo viene nascosto " +
          "mantenendo solo l'icona per non occupare spazio.",
      },
      {
        id: "20260625-cloud-first-sync",
        kind: "fix",
        title: "FIX CRITICO · I dati ora sono condivisi tra dispositivi",
        body:
          "Risolto un bug critico per cui dispositivi diversi vedevano dati diversi e " +
          "la modalità incognito non vedeva nulla. La causa: i dati operativi " +
          "(corrispettivi, buste, versamenti, dipendenti, banche, plichi, fornitori) " +
          "erano salvati SOLO nel localStorage del browser e il backup cloud era " +
          "opt-in. Da oggi i dati sono salvati SUL SERVER come fonte autoritativa: " +
          "all'avvio dell'app vengono caricati dal cloud (su ogni dispositivo, anche " +
          "in incognito) e ad ogni modifica vengono sincronizzati automaticamente " +
          "(debounce 1,5s). In Impostazioni → Backup & Sincronizzazione il messaggio " +
          "spiega ora il nuovo comportamento; il toggle è diventato \"Disattiva sync " +
          "auto (debug)\" e resta unchecked di default. Verifica end-to-end completata " +
          "(backend + frontend, login multi-context).",
      },
      {
        id: "20260625-storico-accessi-paginazione",
        kind: "feat",
        title: "Storico accessi: paginazione e ordinamento server-side",
        body:
          "Lo Storico accessi (Impostazioni → Storico accessi) ora pagina tutti i risultati " +
          "anziché mostrare solo le ultime 50 righe. In fondo alla tabella trovi i pulsanti " +
          "\"Prec.\" e \"Succ.\" con l'indicatore \"Pagina X di Y · N eventi totali\". " +
          "L'ordinamento per Quando / Evento / IP è gestito lato server e copre l'intero " +
          "dataset (non più solo la pagina visibile); il sort per Utente resta client-side " +
          "sulla pagina caricata. Cambiando filtro Evento o Periodo la paginazione si " +
          "resetta automaticamente alla prima pagina.",
      },
      {
        id: "20260625-sort-tabelle",
        kind: "feat",
        title: "Ordinamento per colonna su tutte le tabelle principali",
        body:
          "Lo stesso pattern di sort introdotto nella tabella \"Giornate disponibili\" è ora " +
          "disponibile in tutte le tabelle chiave dell'app: Corrispettivi → Riepilogo Mensile " +
          "(Data, Negozio, Operatore, Busta, POS, Totali, Spese, Fatture, Scontrini, Stato), " +
          "Versamenti (Codice, Area, Destinatario, Data, Totale, Stato, Plico), Impostazioni → " +
          "Utenti (Nome, Email, Ruolo, Area, Negozi, Codice, Stato, Ultimo accesso) e Storico " +
          "accessi (Quando, Evento, Utente, IP). Su tutte: click1 = asc, click2 = desc, " +
          "click3 = reset al default; colonna attiva evidenziata con freccia direzionale e " +
          "colore brand. Nel Riepilogo Mensile la riga TOTALE MESE resta sempre in fondo. " +
          "Refactor: introdotto helper riutilizzabile (`_sortTh`/`_sortBy`/`_sortApply`) per " +
          "mantenere uniformità UX e ridurre duplicazione futura.",
      },
      {
        id: "20260625-buste-sort-colonne",
        kind: "feat",
        title: "Ordinamento per colonna nella tabella \"Giornate disponibili\" (Buste)",
        body:
          "Nella tab Buste, la tabella \"Giornate disponibili — seleziona per creare busta\" " +
          "ora supporta l'ordinamento cliccando su qualsiasi intestazione di colonna: Data, " +
          "Negozio, Contanti busta, Scontrini, Stato, Quadr., Busta. Un click ordina ascendente, " +
          "il secondo discendente, il terzo ripristina l'ordinamento di default (Negozio + Data " +
          "asc). La colonna attiva è evidenziata con una freccia direzionale e colore brand. " +
          "Il sort è in-memory (non altera i dati), e i filtri Zona/Negozio/Mese vengono " +
          "applicati prima dell'ordinamento.",
      },
      {
        id: "20260625-audit-admin-events",
        kind: "feat",
        title: "Storico accessi: nuova sezione \"Eventi admin\"",
        body:
          "Lo Storico accessi (Impostazioni → Storico accessi, lv5) ora include anche tutti " +
          "gli eventi di gestione utenti, utili soprattutto da quando l'Amministrazione (lv4) " +
          "può creare e gestire utenti. Il filtro \"Evento\" è raggruppato in due categorie: " +
          "\"Accessi\" (i login storici) e \"Eventi admin\" (Utente creato/modificato/eliminato, " +
          "Codice rigenerato dall'admin o self-service, Codice manuale, Codice da backfill, " +
          "Import utenti). Per ogni evento admin viene mostrato chi ha agito (actor) e " +
          "l'utente impattato (target), con i dettagli rilevanti (campi cambiati, conteggi " +
          "dell'import, esito invio email). Anche gli utenti già eliminati restano tracciabili " +
          "grazie allo snapshot di nome/email salvato nel log.",
      },
      {
        id: "20260625-lv4-user-management",
        kind: "feat",
        title: "Amministrazione (lv4) può creare e gestire utenti",
        body:
          "Il ruolo Amministrazione (lv4) ha ora accesso al pannello Impostazioni → Utenti, " +
          "esattamente come il Super Admin (lv5): può creare nuovi utenti, modificarli, " +
          "rigenerare i codici, attivarli/disattivarli, eliminarli ed eseguire import XLSX/CSV. " +
          "Restano riservate al solo Super Admin: la gestione degli altri Super Admin " +
          "(creazione, promozione a lv5, modifica, eliminazione, rigenerazione codice e " +
          "disattivazione), la rigenerazione massiva dei codici, la configurazione dei " +
          "riepiloghi email e lo Storico accessi. Nell'interfaccia, le azioni non disponibili " +
          "per lv4 sui Super Admin vengono mostrate disabilitate con un'icona di lucchetto e " +
          "tooltip esplicativo; l'opzione \"Super Admin\" è nascosta dal selettore Ruolo " +
          "quando l'attore è un Amministrazione.",
      },
    ],
  },
  {
    date: "2026-06-24",
    items: [
      {
        id: "20260624-fatture-pos-toggle",
        kind: "feat",
        title: "Pulsante POS sulle fatture per quadrare con la chiusura POS",
        body:
          "Quando aggiungi una fattura nel form di nuova/modifica giornata, accanto all'importo trovi " +
          "ora un pulsante \"POS\". Cliccandolo, la fattura viene esclusa dal calcolo dei contanti in " +
          "busta (Busta + Fatture contanti + Spese = Fresha contanti) e contemporaneamente entra nel " +
          "controllo POS, dove la formula diventa: Fresha POS = RT POS + Fatture POS = POS fisico " +
          "chiusura. Utile quando una fattura viene saldata via terminale: i due controlli quadrano " +
          "entrambi senza dover \"truccare\" gli importi. Visivamente: pulsante grigio = contanti " +
          "(default), pulsante blu con icona carta = POS.",
      },
      {
        id: "20260624-elimina-modifica-data",
        kind: "feat",
        title: "Cestino \"Elimina giornata\" + modifica data per Admin e SA",
        body:
          "Per i ruoli Amministrazione (lv4) e Super Admin (lv5) sono stati aggiunti due strumenti " +
          "richiesti per correggere errori di inserimento: (1) un pulsante 🗑️ \"Elimina giornata\" " +
          "compare ora sia nella card del corrispettivo giornaliero che in ogni riga del Riepilogo " +
          "Mensile (Corrispettivi → Riepilogo mensile), con conferma esplicita prima dell'eliminazione " +
          "definitiva. (2) Quando si apre una giornata in Modifica, il campo \"Data giornata\" è ora " +
          "editabile (solo per lv4/lv5), così da poter sistemare giornate inserite con data sbagliata o " +
          "duplicata. Un controllo automatico impedisce di salvare se la nuova data coincide con un'altra " +
          "giornata già esistente per lo stesso negozio.",
      },
      {
        id: "20260624-am-multi-zona",
        kind: "feat",
        title: "Area Manager può gestire più zone",
        body:
          "Nel form \"Nuovo utente\" e \"Modifica utente\", quando selezioni il ruolo \"Area Manager\", " +
          "il campo \"Area\" diventa un menu a tendina con checkbox per assegnare più zone alla stessa " +
          "persona (es. Nord Est + Nord Ovest). I riepiloghi automatici via email includono " +
          "automaticamente i negozi di tutte le zone assegnate, e la tabella Utenti mostra le aree " +
          "multiple come badge separati. Per tutti gli altri ruoli il selettore rimane a scelta singola " +
          "come prima.",
      },
      {
        id: "20260624-storico-accessi-sa",
        kind: "feat",
        title: "Storico accessi visibile al Super Admin",
        body:
          "In Impostazioni → \"Storico accessi\" il Super Admin trova ora una tabella con la cronologia " +
          "di chi è entrato nell'app, da dove e quando: accessi di negozi, operatori, area manager, " +
          "admin e Super Admin, oltre ai tentativi falliti (codice errato, codice incompleto, codice " +
          "personale digitato senza prima entrare nel negozio, operatore non assegnato al negozio). " +
          "Per ogni evento sono visibili: orario, tipo evento (etichetta colorata), nome utente con " +
          "ruolo, contesto (negozio · area · motivo del fallimento), IP. Filtri disponibili: tipo di " +
          "evento, periodo (7/30/90/365 giorni). I dati restano disponibili anche per utenti " +
          "successivamente cancellati grazie a uno snapshot dei nomi al momento dell'accesso.",
      },
    ],
  },
  {
    date: "2026-06-22",
    items: [
      {
        id: "20260622-code-review-fix",
        kind: "fix",
        title: "Code quality: variabili definite e linting puliti",
        body:
          "Applicati i fix segnalati dal report di code review: variabili `start`/`end` ora sempre " +
          "inizializzate in `send_summary()` per silenziare i linter statici, uso di `==` al posto di " +
          "`is` per confronti con `True` nei test, e apostrofi non escape-ati nella pagina changelog " +
          "sostituiti con `&apos;`. Nessun cambio funzionale, solo robustezza.",
      },
      {
        id: "20260622-pdf-export-tabs",
        kind: "feat",
        title: "Scarica PDF di Buste, Versamenti e Plichi Banca",
        body:
          "Su ciascuno dei tre tab \"Buste\", \"Versamenti\" e \"Trasferimento\" trovi ora un pulsante " +
          "\"PDF\" in alto a destra: con un click scarichi un PDF in orientamento orizzontale con il " +
          "riepilogo delle voci attualmente filtrate (zona/negozio/mese), pronto da archiviare o " +
          "inoltrare. Il PDF include intestazione brand, riga totale e data di generazione.",
      },
      {
        id: "20260622-admin-vede-trasferimenti",
        kind: "feat",
        title: "Amministrazione vede anche \"Trasferimento\"",
        body:
          "Il ruolo Amministrazione (ADM) ha ora accesso alla sezione \"Trasferimento — Plico Banca\" " +
          "in sola lettura, in linea con Versamenti e Buste. Utile per il controllo dei flussi senza " +
          "necessità del Super Admin.",
      },
      {
        id: "20260622-zero-negozi-utenti",
        kind: "feat",
        title: "Operatori e Shop Manager possono essere creati senza negozi",
        body:
          "Rimossa la validazione bloccante che richiedeva almeno un negozio per Operatori e Shop Manager. " +
          "Ora puoi creare/modificare un utente lv1 o lv2 senza assegnargli alcuna sede: utile per " +
          "\"parcheggiare\" temporaneamente un account, oppure per dipendenti non ancora destinati a un negozio. " +
          "Nota: gli operatori senza negozi non compariranno nella schermata di accesso di nessuna sede finché " +
          "non vengono assegnati.",
      },
      {
        id: "20260622-fix-picker-fantasma",
        kind: "fix",
        title: "Fix \"Nessun negozio\" che si autoselezionava nel form utenti",
        body:
          "Nel form \"Nuovo utente\" / \"Modifica utente\", il dropdown \"Negozi assegnati\" mostrava in cima " +
          "una riga \"Seleziona tutti\" che, quando si arrivava a selezionare tutti i negozi disponibili, " +
          "veniva flaggata automaticamente. Sembrava un'opzione fantasma chiamata \"Nessun negozio\" che si " +
          "attivava da sola. Risolto: la riga è stata rimossa dal form utenti (resta solo dove serve davvero, " +
          "cioè nell'assegnazione fornitori a negozi). Da ora in poi spunta solo i negozi a cui devi assegnare " +
          "l'operatore, niente più toggle confondente.",
      },
      {
        id: "20260622-fix-picker-checkbox",
        kind: "fix",
        title: "Fix layout dropdown \"Negozi assegnati\"",
        body:
          "Le checkbox del menu a tendina apparivano deformate (allungate a tutta larghezza) " +
          "spingendo i nomi dei negozi a destra. Risolto: le checkbox e i radio button dentro i form " +
          "ora hanno il loro stile nativo e i nomi restano allineati a sinistra accanto a ciascuna " +
          "spunta.",
      },
      {
        id: "20260622-template-import-dinamico",
        kind: "feat",
        title: "Template import XLSX dinamico con elenco negozi attuali",
        body:
          "Il template scaricabile dalla schermata di import utenti ora viene generato al volo e include " +
          "un foglio in più chiamato \"Negozi esistenti\" con la lista dei negozi attualmente configurati. " +
          "Comodissimo per compilare la colonna \"Negozi assegnati\" senza errori di battitura: basta " +
          "aprire il foglio a fianco, copiare il nome e incollarlo. Aggiornate anche le istruzioni: email " +
          "opzionale per le righe di tipo Negozio, avvisi automatici sui nomi non riconosciuti.",
      },
      {
        id: "20260622-import-validazione-negozi",
        kind: "feat",
        title: "Import XLSX: validazione negozi assegnati + email opzionale per negozi",
        body:
          "Il template di import XLSX/CSV ora segnala automaticamente i nomi negozio non riconosciuti " +
          "nella colonna \"Negozi assegnati\": l'utente viene creato lo stesso, ma compare un avviso giallo " +
          "nella schermata di risultato per ricontrollare il nome. Inoltre, l'import accetta righe di tipo " +
          "\"Negozio\" (lv0) anche senza colonna Email, mentre gli altri ruoli (Operatore, SM, AM, Admin) " +
          "continuano a richiederla. Il totale degli avvisi è ora visibile nel sommario in alto.",
      },
      {
        id: "20260622-utenti-negozi-multiselect",
        kind: "ui",
        title: "Negozi assegnati: dropdown a scelta multipla",
        body:
          "Nel form \"Nuovo utente\" e \"Modifica utente\" il campo \"Negozi assegnati\" ora è un menu " +
          "a tendina con checkbox: vedi la lista completa dei negozi esistenti e selezioni uno o più " +
          "con un click, senza dover scrivere il nome a mano. La lista mostra esattamente gli stessi " +
          "negozi della sezione \"Negozi & Fornitori\". " +
          "Se un negozio è stato cancellato in passato, viene automaticamente rimosso dalle assegnazioni " +
          "al primo salvataggio successivo.",
      },
      {
        id: "20260622-negozi-email-opzionale",
        kind: "feat",
        title: "I negozi possono essere creati senza email",
        body:
          "Aggiungere un negozio (utente lv0) non richiede più un indirizzo email: " +
          "il codice di accesso viene mostrato una sola volta al Super Admin nel momento della " +
          "creazione e poi resta visibile nella tabella Utenti (con il pulsante \"occhio\"). " +
          "Per gli altri ruoli (Operatore, Shop Manager, Area Manager, Admin) l'email resta obbligatoria. " +
          "I negozi già esistenti con email auto-generate restano funzionanti; per rimuoverle basta aprire " +
          "\"Modifica utente\" e svuotare il campo Email.",
      },
      {
        id: "20260622-lista-negozi-coerente",
        kind: "ui",
        title: "Lista negozi sempre coerente con gli utenti",
        body:
          "La sezione \"Negozi & Fornitori\" mostra esattamente la stessa lista che vedi in \"Utenti → " +
          "filtra per Negozio\": nessuna divergenza possibile. La colonna Email nella tabella Utenti " +
          "mostra ora \"— (login solo con codice)\" per i negozi senza email. " +
          "Quando elimini o disattivi un utente di tipo \"Negozio\" da Impostazioni → Utenti, sparisce " +
          "subito anche dalla lista in \"Negozi & Fornitori\" e dai dropdown del form giornata.",
      },
    ],
  },
  {
    date: "2026-06-19",
    items: [
      {
        id: "20260619-negozi-unificati",
        kind: "feat",
        title: "Lista negozi unificata: una sola sorgente di verità",
        body:
          "Prima esistevano DUE liste di negozi: gli utenti lv0 in \"Impostazioni → Utenti\" " +
          "(usati per il login) e una configurazione locale visibile in \"Negozi & Fornitori\" " +
          "(usata nei dropdown del form giornata). Le due potevano disallinearsi. Da oggi la " +
          "lista è una sola: gli utenti di tipo \"Negozio\" (lv0) in DB. " +
          "La tab \"Negozi & Fornitori\" mostra le sedi in sola lettura con un link diretto a Utenti per " +
          "crearne, rinominarne o disattivarne. I dropdown del form giornata e tutti i filtri leggono " +
          "in tempo reale dal backend. La sezione Fornitori spese resta interamente gestibile da qui.",
      },
      {
        id: "20260619-login-fast",
        kind: "perf",
        title: "Login fino a 40× più veloce",
        body:
          "Il sistema di verifica del codice di accesso è stato ottimizzato: prima ogni codice digitato " +
          "veniva confrontato uno per uno con tutti gli utenti attivi (operazione bcrypt da ~250 ms per utente), " +
          "facendo arrivare il login a 5–8 secondi in produzione. Ora il controllo passa per un indice " +
          "dedicato e risolve in ~100 ms. Migliora sia il login negozio che l'autenticazione operatore.",
      },
      {
        id: "20260619-modalita-kiosk",
        kind: "feat",
        title: "Modalità Kiosk per il negozio + autenticazione operatore on-demand",
        body:
          "Il flow di accesso negozio è stato semplificato: ora il negozio entra direttamente in app in " +
          "\"Modalità sola lettura\" (kiosk) con banner giallo in cima e badge KIOSK in alto a destra. " +
          "L'autenticazione personale dell'operatore o shop manager avviene SOLO quando si clicca un'azione " +
          "di scrittura (Nuova giornata, Modifica giornata). Appare una piccola finestra con i profili " +
          "del negozio (avatar + nome + ruolo) e il campo per il codice a 6 cifre. " +
          "Una volta autenticato, parte un timer di 15 minuti visibile in alto. " +
          "Allo scadere o cliccando \"Cambia utente\" si torna alla modalità kiosk senza dover rifare il login del negozio.",
      },
      {
        id: "20260619-polish-ui-trasversale",
        kind: "ui",
        title: "Polish UI trasversale: design system uniforme",
        body:
          "Tutta l'interfaccia è stata armonizzata con un nuovo sistema di classi utility " +
          "(card secondarie, tabelle dati, pill di stato, header/footer modali, bottoni). " +
          "Effetti collaterali visibili: schermata di login più moderna, tab Buste con badge \"quadrate\" e " +
          "filtro dedicato, modali più leggibili, card giornata più compatta, focus ring più chiaro " +
          "sugli input. Nessuna feature nuova: solo coerenza visiva e leggibilità migliori su tutti i tab.",
      },
    ],
  },
  {
    date: "2026-06-15",
    items: [
      {
        id: "20260615-riepiloghi-email-avanzati",
        kind: "feat",
        title: "Riepiloghi email automatici: giornaliero, settimanale, mensile",
        body:
          "Nuovo sistema di riepiloghi automatici via email gestibile dal pannello Impostazioni → Email. " +
          "Puoi attivare/disattivare in modo indipendente il riepilogo giornaliero (ore 23:00), " +
          "settimanale (lunedì mattina) e mensile (1° del mese). Ogni utente può inoltre scegliere " +
          "dalla propria scheda quali riepiloghi vuole ricevere (preferenze personali). " +
          "Aggiunte impostazioni per la sezione anomalie e il PDF in allegato (PDF in arrivo).",
      },
      {
        id: "20260615-storico-invii-grafico",
        kind: "feat",
        title: "Storico invii email con grafico mini-chart cliccabile",
        body:
          "In Impostazioni → Email è ora visibile uno storico degli invii recenti con un mini-grafico " +
          "a barre (ultimi 7 invii). Cliccando una barra si apre il dettaglio dell'invio: tipo di riepilogo, " +
          "data/ora, destinatari raggiunti, errori. Utile per verificare l'effettivo recapito.",
      },
      {
        id: "20260615-validazione-contanti-stricta",
        kind: "feat",
        title: "Validazione contanti rigorosa nel form giornata",
        body:
          "Quando salvi/modifichi una giornata, il sistema ora BLOCCA il salvataggio se " +
          "\"Contanti Fresha\" non corrisponde esattamente a \"Busta + Fatture + Spese\". " +
          "Comparirà un pill rosso \"Contanti sbilanciati\" con la differenza esatta. " +
          "Per gli admin esiste comunque l'override consapevole.",
      },
      {
        id: "20260615-filtro-quadrate-buste",
        kind: "feat",
        title: "Filtro \"Solo quadrate\" + badge contatore in Tab Buste e Corrispettivi",
        body:
          "Nuovo filtro \"Solo quadrate\" nella tab Buste e in Corrispettivi: mostra solo le giornate " +
          "con contanti perfettamente bilanciati. Accanto compare un badge verde con il conteggio " +
          "(es. \"✓ 12 quadrate\"). Le giornate sbilanciate hanno invece un'icona 🔧 \"Fix\" che apre " +
          "direttamente la giornata in modifica per la correzione veloce.",
      },
      {
        id: "20260615-utenti-potenziati",
        kind: "feat",
        title: "Pannello Utenti potenziato: modifica email, elimina utenti, export XLSX",
        body:
          "In Impostazioni → Utenti il Super Admin può ora: (1) modificare l'email di un utente esistente, " +
          "(2) eliminare utenti (con protezione hardcoded sui Master SA - Marco, Giuseppe, Max), " +
          "(3) esportare l'intera anagrafica utenti in XLSX con un click. " +
          "Nuovi filtri UI per ruolo/area/stato attivo.",
      },
      {
        id: "20260615-multiselect-fornitori",
        kind: "ui",
        title: "Multi-select fornitori nelle spese",
        body:
          "Quando aggiungi una spesa puoi ora selezionare il fornitore da una checkbox dropdown " +
          "(prima era input libero). Riduce errori di battitura e uniforma i report fornitori.",
      },
      {
        id: "20260615-backfill-codici-legacy",
        kind: "fix",
        title: "Backfill codici visibili per utenti pre-feature",
        body:
          "Gli utenti creati prima dell'introduzione del campo \"Codice visibile\" ora possono essere " +
          "rigenerati in blocco con il pulsante \"Rigenera codici\" in cima alla tabella Utenti. " +
          "Risolve la colonna \"n/d\" per gli account legacy.",
      },
    ],
  },
  {
    date: "2026-06-12",
    items: [
      {
        id: "20260612-codici-visibili",
        kind: "feat",
        title: "Codici di accesso visibili e modificabili",
        body:
          "Nel pannello Utenti il Super Admin ora vede la colonna Codice (mascherata, con occhio per " +
          "rivelarla) e può impostare un codice specifico per ogni utente dal modal Modifica. " +
          "Il sistema impedisce i codici duplicati. I codici creati prima di questo aggiornamento " +
          "risultano \"n/d\": basta reimpostarli o rigenerarli una volta.",
      },
      {
        id: "20260612-dropdown-negozi",
        kind: "ui",
        title: "Dropdown negozi nella nuova giornata",
        body:
          "Per Super Admin e Amministrazione il campo Negozio è ora un menu a tendina con tutte le sedi; " +
          "per gli Area Manager mostra solo i negozi delle aree assegnate. " +
          "L'Area si compila da sola in base al negozio scelto.",
      },
    ],
  },
  {
    date: "2026-06-11",
    items: [
      {
        id: "20260611-gate-profili",
        kind: "ui",
        title: "Profili rapidi nella schermata \"Chi sei?\"",
        body:
          "Il gate del negozio ora mostra i profili degli operatori e shop manager assegnati " +
          "(avatar con iniziali e ruolo, stile selezione profilo). Tocca il tuo profilo e inserisci " +
          "il codice: il cambio turno è questione di secondi.",
      },
      {
        id: "20260611-accesso-2-livelli",
        kind: "feat",
        title: "Accesso a due livelli: Negozio + Utente",
        body:
          "Nuovo modello di accesso: il negozio entra col proprio codice ma non vede nulla — " +
          "appare subito la schermata \"Chi sei?\" che chiede il codice utente personale. Solo operatori " +
          "e shop manager assegnati a quel negozio possono entrare e operare secondo il proprio livello. " +
          "Tasto \"Cambia utente\" per il cambio turno rapido e timeout automatico dopo 30 minuti di inattività. " +
          "Area Manager e Super Admin continuano ad accedere direttamente.",
      },
      {
        id: "20260611-assegnazioni",
        kind: "feat",
        title: "Assegnazioni negozi e aree",
        body:
          "Operatori e shop manager vengono assegnati a uno o più negozi; i negozi e gli area manager " +
          "alle aree (Nord Ovest, Nord Est, Centro, Nord Est Trilab, Nord Est Barbiere). Nel pannello Utenti " +
          "ora puoi modificare ruolo, area e negozi di ogni utente; l'import XLSX ha la nuova colonna \"Negozi\".",
      },
      {
        id: "20260611-fix-lista-negozio",
        kind: "fix",
        title: "Fix: il negozio non vedeva le proprie giornate",
        body:
          "Dopo il salvataggio la giornata veniva registrata (visibile al Super Admin) ma la lista " +
          "del negozio restava vuota: il filtro confrontava ancora il vecchio campo \"negozio\" " +
          "che i nuovi utenti non hanno. Ora il filtro usa il nome dell'utente negozio come fallback.",
      },
      {
        id: "20260611-no-ridondanza",
        kind: "ui",
        title: "Via la ridondanza: Dipendenti → Negozi & Fornitori",
        body:
          "La vecchia tab Dipendenti (operatori con codici a 4 cifre, PIN negozi, log email simulate) " +
          "è stata ripulita: ora si chiama \"Negozi & Fornitori\" e gestisce solo le sedi e i fornitori spese. " +
          "Gli accessi si gestiscono in un unico posto: Impostazioni → Utenti.",
      },
      {
        id: "20260611-destinatari-email",
        kind: "backend",
        title: "Destinatari email serali dagli utenti reali",
        body:
          "Il riepilogo serale ora prende gli Area Manager dagli utenti di sistema (ruolo AM con la loro area) " +
          "invece che dalla vecchia lista dipendenti. La tabella destinatari in Impostazioni si aggiorna " +
          "in automatico e lo storico invii non mostra più eventi estranei.",
      },
      {
        id: "20260611-import-utenti",
        kind: "feat",
        title: "Import massivo utenti e negozi (XLSX/CSV)",
        body:
          "Nuovo bottone \"Importa XLSX/CSV\" nel pannello Utenti: carica un file con colonne " +
          "Nome, Email, Ruolo, Area e Codice (opzionale, 6 cifre — se vuoto viene generato). " +
          "Email già esistente → utente aggiornato. I negozi importati vengono aggiunti anche alla " +
          "configurazione sedi. Template XLSX scaricabile con esempi, istruzioni e menu a tendina per i ruoli.",
      },
      {
        id: "20260611-card-semplificata",
        kind: "ui",
        title: "Card giornaliera semplificata",
        body:
          "Recepito il feedback: i box Cassa e POS mostrano sempre le 3 voci dei corrispettivi " +
          "(Cassa: Fresha / RT / Busta — POS: Fresha / RT / Fisico) con Δ Quadratura. " +
          "Spese ridotto a metà (max 2 movimenti + totale) e Volumi sostituito dal solo numero scontrini. " +
          "Rimossi sparkline, scontrino medio e confronto media: via il rumore di dati che non servono.",
      },
      {
        id: "20260611-font-leggibile",
        kind: "ui",
        title: "Numeri più leggibili",
        body:
          "Il font monospace (DM Mono) esiste solo fino al peso 500: i grassetti 600/700 generavano " +
          "un finto-bold sintetico pesante. Tutti i numeri di card e riepilogo mensile ora usano " +
          "il peso 500 reale, molto più leggibile.",
      },
      {
        id: "20260611-wipe",
        kind: "backend",
        title: "Pulizia dati per il go-live",
        body:
          "Nuovo strumento di reset: mantiene i negozi configurati e gli utenti master, cancella " +
          "giornate, buste, versamenti e utenti di prova. I dispositivi con dati vecchi in locale " +
          "si allineano automaticamente al riavvio dell'app.",
      },
    ],
  },
  {
    date: "2026-06-10",
    items: [
      {
        id: "20260610-audit-diff",
        kind: "feat",
        title: "Storia modifiche con diff valori",
        body:
          "Nuovo bottone (icona ⏱) sulle daily card che apre la cronologia completa: ogni evento mostra " +
          "ruolo (badge colorato), utente, timestamp e — per le modifiche — una tabella con il valore prima (rosso, barrato), " +
          "freccia, e il valore dopo (verde, bold). Backward-compat con gli audit storici.",
      },
      {
        id: "20260610-audit-userid",
        kind: "backend",
        title: "Audit trail rafforzato con userId",
        body:
          "Ogni evento di audit ora registra anche userId e role oltre al nome. Tracciabilità inattaccabile: " +
          "il nome può essere editato a video ma userId no. La giornata salva createdById e createdByRole.",
      },
      {
        id: "20260610-no-op-popup",
        kind: "fix",
        title: "Rimosso popup operatore a 4 cifre",
        body:
          "Il login del negozio porta direttamente alla dashboard, senza step intermedio per riconoscere l'operatore " +
          "(legacy del vecchio sistema PIN). Il campo Operatore nel form è ora testo libero con autocomplete " +
          "se ci sono dipendenti registrati. Per SM/AM/SA è precompilato col nome dell'utente loggato.",
      },
    ],
  },
  {
    date: "2026-06-09",
    items: [
      {
        id: "20260609-6digit",
        kind: "feat",
        title: "Codici di accesso a 6 cifre",
        body:
          "Sostituito il vecchio codice 12-char alfanumerico con un PIN a 6 cifre numeriche, " +
          "più facile da digitare su mobile e familiare come UX. Input con font grande, letter-spacing largo, " +
          "auto-submit al sesto carattere.",
      },
      {
        id: "20260609-seed-shops",
        kind: "feat",
        title: "Setup 8 negozi con codice dedicato",
        body:
          "Creati Roma, Massa, Montebello, Parma, Forlì, Imola, Brescia Elnos, Oriocenter con codice 6 cifre individuale. " +
          "Ogni negozio è un utente lv0 (Negozio): area = nome del punto vendita, può inserire giornaliero ma non editare.",
      },
      {
        id: "20260609-await-bug",
        kind: "fix",
        title: "Email codici: fix critico await mancante",
        body:
          "Risolto bug per cui le email Resend con i codici di accesso non venivano effettivamente inviate (await mancante " +
          "su una funzione async che generava un coroutine mai eseguito). Ora confermato dai log Resend con id consegna valido.",
      },
    ],
  },
  {
    date: "2026-06-08",
    items: [
      {
        id: "20260608-single-code",
        kind: "feat",
        title: "Login con codice unico (no più dropdown utente + PIN)",
        body:
          "Schermata di accesso ridotta a un solo campo: il codice personale. Niente più selezione utente dal dropdown. " +
          "Autenticazione spostata sul backend (MongoDB + bcrypt + JWT), cookie httpOnly di sessione, " +
          "rate-limit 5 tentativi/15min per IP.",
      },
      {
        id: "20260608-resend",
        kind: "feat",
        title: '"Codice perso?" self-service + cooldown',
        body:
          "Link sotto il bottone Accedi per richiedere un nuovo codice via email. Risposta sempre generica per evitare " +
          "enumeration. Bottone con cooldown 60s persistente (countdown live) per scoraggiare lo spam.",
      },
      {
        id: "20260608-admin-users",
        kind: "feat",
        title: "Pannello Admin Utenti in Impostazioni",
        body:
          "Tabella utenti completa (nome, email, ruolo, area, stato, ultimo accesso) con creazione di nuovi account, " +
          "rigenerazione codice (con email auto), attivazione/disattivazione. Visibile solo a Super Admin (lv5). " +
          "Se l'email fallisce, il codice viene mostrato in modale una sola volta con bottone Copia.",
      },
    ],
  },
  {
    date: "2026-06-07",
    items: [
      {
        id: "20260607-mobile-iphone",
        kind: "ui",
        title: "Ottimizzazione UX mobile iPhone",
        body:
          "Pass completo per ≤480px sulle daily card P2: header stack verticale con azioni full-width (touch target 38px), " +
          "mega total in box evidenziato, grid 4 blocchi compatti, sparkline tap area maggiore, checkbox 18×18px. " +
          "Anche header Corrispettivi e tabella popover 7gg riadattati.",
      },
      {
        id: "20260607-fab",
        kind: "ui",
        title: "FAB 'Nuova giornata' mobile con smart-hide",
        body:
          "Bottone fluttuante circolare brand color in basso a destra (visibile solo su mobile e a chi può creare). " +
          "Si nasconde con animazione quando scorri verso il basso, riappare quando scorri verso l'alto. " +
          "Sempre visibile in cima alla pagina.",
      },
      {
        id: "20260607-monthly-cols",
        kind: "ui",
        title: "Riepilogo mensile: nuove colonne",
        body:
          "Rimosse colonne Fresha C e RT C. Nuove: Busta C, POS fisico, Tot. giorno (busta+pos), Spese, " +
          "Fornitore (top + tooltip altri), Fatture, Tot. + Ft (busta+pos+fatture), Scontrini, Stato. " +
          "Riga TOTALE MESE aggiornata coerentemente.",
      },
    ],
  },
  {
    date: "2026-06-06",
    items: [
      {
        id: "20260606-p2-card",
        kind: "ui",
        title: "Daily card ridisegnata (Proposta 2)",
        body:
          "Layout dashboard nuovo per le giornate: header compatto con metadata + azioni a destra, mega total Cassa+POS, " +
          "grid 4 blocchi (Cassa, POS, Spese, Volumi) con confronto vs media mese e Δ quadratura, footer con check Busta SM/AM " +
          "e ultimo audit. Stati colorati: ok (verde), warning (giallo), errore (rosso), chiusa (grigio).",
      },
      {
        id: "20260606-sparkline",
        kind: "feat",
        title: "Sparkline trend 7 giorni",
        body:
          "Nel blocco Volumi delle daily card appare un mini-grafico (SVG inline) con il trend scontrini degli ultimi 7 giorni " +
          "dello stesso negozio. Cliccabile: apre un popover di dettaglio con stats aggregate (totali, media, contanti, POS) " +
          "e tabella giorno per giorno.",
      },
      {
        id: "20260606-monthly-fix",
        kind: "fix",
        title: "Fix riepilogo mensile sempre vuoto",
        body:
          "Risolto bug per cui la tab 'Riepilogo mensile' mostrava lo stato vuoto anche con giornalieri presenti. " +
          "Cause: filtro date timezone-sensitive + mese corrente persistito senza dati. Ora il filtro usa stringhe ISO " +
          "(no timezone) e c'è auto-jump al mese più recente con dati + quick-link nei mesi disponibili.",
      },
    ],
  },
  {
    date: "2026-06-04",
    items: [
      {
        id: "20260604-csv-setup",
        kind: "feat",
        title: "Setup massivo via CSV + brand multi-marchio",
        body:
          "Nuova entità Brand, ogni negozio assegnato a un brand. Reset dati completo (mantiene solo Super Admin + brand default) " +
          "e import CSV in 3 step: scarica template (brands/negozi/dipendenti), compila in Excel, ricarica. " +
          "Parser robusto con validazione duplicati e report Aggiunti/Aggiornati/Saltati.",
      },
      {
        id: "20260604-remove-cheats",
        kind: "fix",
        title: "Rimossi suggerimenti credenziali demo dalla login",
        body:
          "La schermata di accesso non mostra più il box con i PIN demo. " +
          "Migliora sicurezza percepita e prepara l'app per ambiente produttivo reale.",
      },
      {
        id: "20260604-fornitori-multi",
        kind: "feat",
        title: "Fornitori multi-sede",
        body:
          "Ogni fornitore può essere assegnato a uno o più negozi. " +
          "Il selettore spese in Corrispettivi filtra dinamicamente in base alla sede selezionata: solo i fornitori " +
          "assegnati a quel negozio (o lasciati \"Tutti i negozi\") compaiono nel dropdown.",
      },
    ],
  },
  {
    date: "2026-06-03",
    items: [
      {
        id: "20260603-user-mgmt",
        kind: "feat",
        title: "Gestione utenti completa",
        body:
          "Tre nuovi controlli nella tab Dipendenti: pulsante \"Rigenera codice\" per dipendenti " +
          "(genera 4 cifre random + invia email reset via Resend), \"Modifica PIN\" per i negozi (solo Super Admin), " +
          "e invio automatico email di invito al primo inserimento di un dipendente con email.",
      },
      {
        id: "20260603-security-alerts",
        kind: "feat",
        title: "Notifiche sicurezza al titolare",
        body:
          "Email automatica a info@littleitalybarbershop.it ogni volta che: " +
          "(1) un codice operatore viene rigenerato, (2) un PIN negozio viene cambiato, " +
          "(3) un utente effettua il login da un device mai visto. Audit log persistito su MongoDB.",
      },
      {
        id: "20260603-device-tracking",
        kind: "backend",
        title: "Device tracking + alert nuovo dispositivo",
        body:
          "Nuovo endpoint POST /api/auth/log-login: il frontend genera un UUID persistente in " +
          "localStorage e lo invia ad ogni login. Se la coppia (user_id, device_id) è inedita, " +
          "viene inviata un'email di sicurezza al titolare e il device viene registrato.",
      },
      {
        id: "20260603-fix-bold-email",
        kind: "fix",
        title: "Bold nelle email security",
        body:
          "I tag <b> nei template di security alert venivano renderizzati come testo letterale " +
          "a causa dell'autoescape Jinja2. Risolto con {{ message | safe }} nel template + " +
          "markupsafe.escape() sui valori utente prima dell'embed (protezione XSS preservata).",
      },
    ],
  },
  {
    date: "2026-05-25",
    items: [
      {
        id: "20260525-daily-summary",
        kind: "feat",
        title: "Riepilogo giornaliero via email automatico",
        body:
          "Scheduler APScheduler attivo: ogni sera alle 23:00 (Europe/Rome) parte automaticamente l'invio " +
          "del riepilogo del giorno via Resend. Gli Area Manager ricevono solo i dati dei propri negozi " +
          "(filtrati per area), info@littleitalybarbershop.it riceve il riepilogo completo.",
      },
      {
        id: "20260525-cloud-backup",
        kind: "feat",
        title: "Backup cloud + export JSON",
        body:
          "Nuova tab \"Impostazioni\" (visibile ad Amministrazione e Super Admin): " +
          "backup manuale su MongoDB, ripristino cloud, toggle backup automatico ad ogni modifica, " +
          "export/import file JSON. Storico ultimi 10 invii email visibile inline.",
      },
      {
        id: "20260525-resend",
        kind: "backend",
        title: "Integrazione Resend",
        body:
          "Wrapper services/email.py async con retry esponenziale, idempotency key, " +
          "EmailConfigError/EmailSendError per gestione errori controllata. Templates Jinja2 " +
          "in templates/email/ (daily_summary, credentials, security_alert).",
      },
    ],
  },
  {
    date: "2026-05-22",
    items: [
      {
        id: "20260522-deploy",
        kind: "feat",
        title: "Deploy su Emergent + dominio incassi.littleitalybarbershop.it",
        body:
          "Prima messa in produzione dell'app. Frontend React (shell iframe full-screen) " +
          "che serve il file app.html standalone. Backend FastAPI + MongoDB pronto per estensioni.",
      },
    ],
  },
];

const KIND_META = {
  feat:    { label: "Novità",      cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  fix:     { label: "Fix",         cls: "bg-amber-50 text-amber-700 border-amber-200" },
  ui:      { label: "UI",          cls: "bg-sky-50 text-sky-700 border-sky-200" },
  perf:    { label: "Performance", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  backend: { label: "Backend",     cls: "bg-slate-100 text-slate-700 border-slate-200" },
  test:    { label: "Test",        cls: "bg-zinc-100 text-zinc-700 border-zinc-200" },
};

export { ENTRIES, KIND_META };
